import React from "react";
import { Grid } from "@mui/material";

import GridListItem from "components/common/grid/GridListItem";
import CiedDeviceInformationPreviewItem from "components/pages/transmissions/modal/patient/tabs/deviceInformation/preview/CiedDeviceInformationPreviewItem";

const DeviceInformationPreview = ({ currentDevice, isPrimaryDevice }) => {
  const { rpm_devices } = currentDevice || {};

  return (
    <Grid container columnSpacing={3} className="view-pdf__drawer-grid">
      <CiedDeviceInformationPreviewItem
        deviceInformation={currentDevice}
        isPreviousDevices={false}
      />

      {isPrimaryDevice && rpm_devices?.length > 0 && (
        <>
          <Grid container item>
            <Grid
              item
              xs={10}
              style={{ textAlign: "left", margin: "15px 0 5px" }}
            >
              <div className="device-info__device-title">RPM DEVICE</div>
            </Grid>
          </Grid>

          {rpm_devices.map((deviceInfo) => (
            <Grid
              container
              item
              columnSpacing={3}
              className="view-pdf__drawer-grid"
              key="deviceInfo"
            >
              <GridListItem
                title="RPM DEVICE TYPE"
                subTitle={deviceInfo.rpmDeviceName ?? "—"}
                size="3"
              />

              <GridListItem
                title="IMEI"
                subTitle={deviceInfo.imei ?? "—"}
                size="3"
              />

              <GridListItem
                title="ACTIVE"
                subTitle={deviceInfo?.active ? "Yes" : "No"}
                size="3"
              />
            </Grid>
          ))}
        </>
      )}
    </Grid>
  );
};

export default DeviceInformationPreview;
